<template>
  <div class="maincontent">
    <Header title="编辑油卡" @handle="postAdd" :show="true">
      <template #right>
        <span>保存</span>
      </template>
    </Header>
    <div class="pageSmallShadow middle">
      <van-field class v-model="confirm" label="卡类型" :value="confirm" readonly />
      <van-field
        type="text"
        label="卡号"
        :maxlength="mlength"
        :value="cardNumber ? cardNumber.replace(/(.{4})/g,'$1 ') : ''"
        disabled
      />
      <van-field v-model="userName" label="持卡人" placeholder="持卡人" :value="userName" maxlength="6" />
      <van-field
        v-model="phone"
        label="手机号码"
        placeholder="接收通知手机号码"
        :value="phone"
        type="number"
        maxlength="11"
      />
    </div> 
  </div>
</template>
<script> 
import {  addUpdateOilCard } from "api/submit";
export default {
  components: {},
  data() {
    return {
      remark: "100011开头非副卡",
      classId: 0,
      mlength: 19,
      cardNumber: null,
      confirm: "",
      userName: "",
      phone: null,
      model: {},
      cardId:0
    };
  },
  mounted() {
    this.cardId=this.$route.query.cardId; 
    this.classId=this.$route.query.type; 
    this.confirm=this.classId==0?"中国石化":"中国石油"; 
    this.cardNumber=this.$route.query.cardNumber; 
    this.userName=this.$route.query.userName; 
    this.phone=this.$route.query.phone; 
  },
  methods: { 
    postAdd() {
      if (this.userName != null && this.userName != "") {
        if (!this.$regSymbol(this.userName)) {
          this.$error("持卡人姓名只能输入中文汉字");
          return;
        }
      } else {
        this.$error("请输入持卡人");
        return;
      }
      if (!this.$regPhone(this.phone)) {
        this.$error("请输入正确的手机号码");
        return;
      }
      if (
        this.userName == this.model.holder &&
        this.phone == this.model.phone
      ) {
        this.$error("信息无修改");
      } else {
        this.$loading("请求中");
        this.AddCard();
      }
    },
    AddCard() {
      addUpdateOilCard(
        this.cardId,
        this.cardNumber,
        this.classId,           
        this.userName,
        this.phone,
      )
        .then((res) => {
          if (res.status == 200) {
            this.$successSync("保存成功", () => {
              this.$push({
                path: "/onLineIndex",
                query: { ident: "oilRecharge",name:"油卡充值",id:"655f4a4a7b544b37bc9c2c66f1944850" },
              });
            });
          } else {
            this.$error(res.message);
          }
        }) 
    },
  },
};
</script> 
<style lang="less" scoped>
.maincontent {
  border-radius: 10px;
  .middle { 
    .van-cell::after {
      border-bottom: 0.01rem solid #ebedf0 !important;
    }
    .van-cell {
      line-height: 40px;
    }
  }
}
</style>